import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
let pageGap = class pageGap extends Vue {
  async validate() {
    return true;
  }
};
pageGap = __decorate([Component({
  name: "pageGap",
  components: {}
})], pageGap);
export default pageGap;